import { featureEnabled, isCustomerAdmin, isTermitel, projectFeatureEnabled } from "./helpers";

export interface ProjectMayInterface {
  (session: SessionInterface, path: "project/uploads"): boolean;
  (session: SessionInterface, path: "project/uploads", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "project/uploads",
    action: "show" | "edit" | "delete" | "mark_done",
    group: UploadDetail,
  ): boolean;

  (session: SessionInterface, path: "project/hotseat"): boolean;

  (session: SessionInterface, path: "project/attachments"): boolean;
  (session: SessionInterface, path: "project/attachments", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "project/attachments",
    action: "edit" | "delete",
    group: ProjectAttachment,
  ): boolean;
}

const UPLOAD_PERMISSIONS: PermissionType<UploadDetail> = {
  "project/uploads": {
    index: ({ currentProject, currentUser }) => featureEnabled(currentUser, currentProject, "uploads"),
    mark_done: ({ currentProject, currentUser }, upload) =>
      featureEnabled(currentUser, currentProject, "uploads") && upload.status === "NEW" && isTermitel(currentUser),
  },
};

const HOT_SEAT_PREMISSIONS: PermissionType<any> = {
  "project/hotseat": {
    index: ({ currentProject, currentUser }) =>
      projectFeatureEnabled(currentProject, "hotseat") && isTermitel(currentUser) && currentProject.attrs.hotseat_link,
  },
};

const ATTACHMENT_PREMISSIONS: PermissionType<ProjectAttachment> = {
  "project/attachments": {
    index: ({ currentCustomer, currentUser }) =>
      isTermitel(currentUser) && isCustomerAdmin(currentUser, currentCustomer),
  },
};

const ProjectPermissions = {
  ...UPLOAD_PERMISSIONS,
  ...HOT_SEAT_PREMISSIONS,
  ...ATTACHMENT_PREMISSIONS,
};

export default ProjectPermissions;
